import ajax from '../../common/services/httpService'
import axios from 'axios'

const BASE_URL = 'contact'
const API_BASE = process.env.NODE_ENV === 'production' ? '/api/' : 'http://localhost:3000/api/'

async function getFilterdContacts(filter) {
	const res = await ajax.get(`${BASE_URL}/filtered`, null, filter)
	return res
}

async function getContactById(id) {
	const res = await ajax.get(`${BASE_URL}/${id}`)
	return res
}

async function removeContactById(id) {
	const res = await ajax.delete(`${BASE_URL}/${id}`)
	return res
}

async function saveContact({ id, username, phone, device, lang, userId, workingAreaIds, roomIds, isActive, shiftIds, appPagesIds, role }) {
	const contactToSave = {
		id, // Contact ID
		username,
		phone, // Phone
		lang, // Language
		device, // Device
		user_id: userId, // User ID
		working_area_id: workingAreaIds, // Working Area IDs
		room_ids: roomIds, // Room IDs
		is_active: isActive, // Is Active,,
		shift_ids: shiftIds,
		app_pages_ids: appPagesIds,
		role: role || null
	}
	if (id) {
		const res = await ajax.put(`${BASE_URL}`, {
			contact: contactToSave
		})
		return res
	}
	const res = await ajax.post(`${BASE_URL}`, {
		contact: contactToSave
	})
	return res
}

async function isUsernameValid(username) {
	try {
		const isValid = await ajax.get(`${BASE_URL}/is-username-valid`, null, { username });
		return isValid;
	} catch (err) {
		throw new Error('server had problem testing username');
	}
}

async function isPhoneValid(phone) {
	try {
		const isValid = await ajax.get(`${BASE_URL}/is-phone-valid`, null, { phone });
		return isValid;
	} catch (err) {
		throw new Error('server had problem testing phone');
	}
}

function getDefaultContact() {
	return {
		phone: '',
		username: '',
		lang: '',
		userId: '',
		device: '',
		workingAreaIds: [],
		roomIds: [],
		isActive: true,
		shiftIds: [],
		appPagesIds: [],
		role: ''
	}
}

async function getAppPages() {
	const res = await ajax.get(`${BASE_URL}/appPages`)
	return res
}

async function getAppUserSettings(phoneNumber) {
	try {
		const res = await axios.get(`${API_BASE}${BASE_URL}/${phoneNumber}/settings`, { withCredentials: true })
		return res.data
	} catch (err) {
		// 404 = user hasn't logged into the app yet, no settings exist - return null silently
		return null
	}
}

async function updateAppUserSettings(phoneNumber, settings) {
	try {
		const res = await axios.put(`${API_BASE}${BASE_URL}/${phoneNumber}/settings`, settings, { withCredentials: true })
		return res.data
	} catch (err) {
		// 404 = user hasn't logged into the app yet, can't update settings - return null silently
		return null
	}
}

async function getContactNotificationHealth(phoneNumber) {
	const res = await axios.get(`${API_BASE}${BASE_URL}/${phoneNumber}/notification-health`, { withCredentials: true })
	return res.data
}

async function getAssignmentCheck(siteId) {
	const res = await ajax.get(`${BASE_URL}/assignment-check`, null, { siteId })
	return res
}

export { getFilterdContacts, getContactById, removeContactById, saveContact, getDefaultContact, isUsernameValid, isPhoneValid, getAppPages, getAppUserSettings, updateAppUserSettings, getContactNotificationHealth, getAssignmentCheck }
